import { useTheme } from "react-jss";
import { IDockDisplayWaiting } from "../../../../models/management/dockDisplay/IDockDisplay";
import { ManagementDockDisplayWaitingVehiclesStyle } from "./waitingStyle.jss";

interface IManagenmentDockDisplayWaitingVehiclesProps {
    displayWaiting?: IDockDisplayWaiting[];
}

export const ManagementDockDisplayWaitingVehicles: React.FC<IManagenmentDockDisplayWaitingVehiclesProps> = ({ displayWaiting }) => {
    const theme = useTheme();
    const itemCount = displayWaiting?.length || 0;
    const style = ManagementDockDisplayWaitingVehiclesStyle({ theme, itemCount });
  
    const getGridRowEndValue = (numberOfItems: number): number => {
        const m = 2.33;
        const b = 3.67;
        return Math.ceil(m * numberOfItems + b);
    };

    return (
        <div className={style.containerWaiting}>
            {displayWaiting?.map((item) => (
                <div
                    className={style.gridContainer}
                    key={item.sort}
                    style={{ gridRowEnd: `span ${getGridRowEndValue(item.minimumSort)}` }}
                >
                    <div className={style.containerTitle}>
                        <div className={style.titleWaiting}>{item.description}</div>
                        <div className={style.line}></div>
                    </div>
                    <div className={style.itemList}>
                        {item.waitingData.map((data) => {
                            return <div key={data.sort}>{data.transportUnitNumber}</div>;
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};
